define.alias("checkout/components/payment/stripe-payment-element/index", "settings/components/payment/stripe-payment-element/index");